import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import EventsBackgroundColor from "./../Shared/EventsBackgroundColor";
import { BrowserView, MobileView, isBrowser, isMobile, isSmartTV, withOrientationChange } from "react-device-detect";
import OwlCarousel from "react-owl-carousel2";
import { Link, withRouter } from "react-router-dom";
const { 
  getCategory
} = require("../Shared/utils");


class PeriodEvent extends Component {
  state = {
    periodList: []
  }

  // componentWillReceiveProps = (nextProps) => {
  //   console.log("componentWillReceiveP");
  //   console.log("componentWillReceivePropsPeriodEventMountx", nextProps);
  // }

  componentWillMount = () => {
    // console.log("propsPeriodEventMount", this.props);
    var id = window.location.pathname.split('/')
    var periodId = id[3]
    var periodFilter =  this.props.location.state.items.filter((item)=>{
      return item.period_id == periodId
    })
    // console.log('periodFilter',periodFilter)

    this.setState({
      periodList: periodFilter[0].list,
      periodName: periodFilter[0].period_name,
      period: periodFilter[0]
    })
  }

  handleClicks = (periodId, categoryId, eventId) => {
    // window.location.replace(`/timeline/#${periodId}/?periodId=${periodId}&categoryId=${categoryId}&eventId=${eventId}`);
    window.location.replace(`/epa_timeline/#id${eventId}`);
  }


  render() {
    const options = {
      items: 1,
      nav: true,
      rewind: true,
      autoplay: true,
      navElement: '<div>smaple</div>'
  };
  
  const events = {
    onDragged: function(event) {},
    onChanged: function(event) {}
};

  // console.log("statePeriodEvent", this.state);
  var { periodList, periodName, period } = this.state
  var period_name = periodName.replace(/\s/g,'').toLowerCase()
  var regex = /(<([^>]+)>)/gi;
  return (
    <div>
      <div id="carouselExampleControls" className="carousel slide" data-ride="carousel" data-interval="false">
        <div className="carousel-inner">
        {periodList.map((item, ind)=>{
            return (
              <div className={`carousel-item ${ind == 0 ? 'active' : ''}`}>
                <div
                className={`container-period col-xl-12 period-container bg-img p-0`}
                style={{
                  backgroundImage: `url('${period.background_image == null ? '': period.background_image.meta.download_url}')`,
                  // backgroundColor: `${period.period_color}`,
                  // backgroundBlendMode: "soft-light",
                  width: '100vw'
                }}
              >
              <div class="inner">
                <div className={`${item.photo == null ? 'center-div' : ''}`}>
                  {item.photo == null ? '' : 
                        (
                      <div className={`${item.photo.width > item.photo.height && item.photo.height < 450? 'col-8 col-lg-8 col-xl-8 m-auto p-0 landscape' : item.photo.width < item.photo.height && item.photo.height >= 450 ? 'col-8 col-lg-3 col-xl-3 m-auto p-0 portrait' : 'col-8 col-lg-3 col-xl-3 m-auto p-0 even'}`}>
                          <div class="pt-1">
                            <div>
                              {/* <a href={item.photo.url} data-lightbox={item.id} data-title={item.caption}> */}
                                <img className="w-100 img-sample" src={item.photo.url} />
                              {/* </a> */}
                            </div>
                          </div>
                      </div>
                    )
                  }
                  <Grid className="m-0 pb-5">
                    <Grid.Column width={2}></Grid.Column>
                    <Grid.Column width={11} className="mt-0 ml-3 px-0 pb-0 pt-2 m-auto">
                      <div className="mt-4">
                        <p className="event-title-historical text-white mt-3">
                          {item.display_name == "" || item.display_name == null
                                            ? item.complete_start_date
                                            : item.display_name}
                          <span className={`event-category text-white  ${item.category == '' || item.display_name == '' || item.complete_start_date == '' ? "d-none" : ""}`}>| {item.category}</span>
                        </p>
                      </div>
                      <div className="col-md-6 mt-2 p-0">
                        <hr className="hr-gold mb-2 mt-2" />
                      </div>
          
                      <p className="event-description-historical text-white font-style-3">
                        {/* {item.description.replace(regex, "")} */}
                        <div dangerouslySetInnerHTML={{ __html: `${item.description}` }} />
                      </p>
                    </Grid.Column> 
                    <Grid.Column width={2}></Grid.Column>
                  </Grid>
                </div>
              </div>
                <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <span className="navicon-icon">
                    <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
                      <g id="prev" transform="translate(8.500000, 8.500000) scale(-1, 1) translate(-8.500000, -8.500000)">
                          <polygon className="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                          <polygon className="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                          <path d="M-1.48029737e-15,0.56157424 L-1.48029737e-15,16.1929159 L9.708,8.33860465 L-2.66453526e-15,0.56157424 L-1.48029737e-15,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z"></path>
                      </g>
                    </svg>
                  </span>
                </a>
                <a className="carousel-control-next zIndex-99" href="#carouselExampleControls" role="button" data-slide="next">
                  <span className="navicon-icon">
                    <svg width="18px" height="17px" viewBox="-1 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
                        <g>
                            <polygon className="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                            <polygon className="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                            <path d="M-4.58892184e-16,0.56157424 L-4.58892184e-16,16.1929159 L9.708,8.33860465 L-1.64313008e-15,0.56157424 L-4.58892184e-16,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z"></path>
                        </g>
                    </svg>
                  </span>
                </a>
                <div class="zIndex-999">
                  <div class="">
                  <Link className="link-event" to={{
                        pathname: `/#id${item.id}`,
                        state: {
                          periodId:  period.id, 
                          categoryId:  item.categories[0].pk, 
                          categoryName:  getCategory(item.categories[0].pk), 
                          eventId: item.id
                        }
                      }}>
                    <Button className="top-left-corner rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down" onClick={this.handleClicks.bind(this, period.id, item.categories[0].pk, item.id)}>
                    {/* <Button className="rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down"> */}
                      <Icon name="long arrow alternate left" />
                      Back
                    </Button>
                    </Link>
                  </div>
                </div> 
                <div class="">
                  <div class="">
                  <p className="top-right-corner event-slider-period-category text-white text-uppercase text-right ">
                        {period.period_slider_display_name}
                  </p>
                  </div>
                </div> 
              </div>
            </div>
            )
          })}
        </div>
        </div>
      </div>
    );
  }
}

export default PeriodEvent;
